<template>
  <div class="container">
    <h1>Passcode</h1>
  </div>
</template>

<script>
export default {
  name: 'Title',
}
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

h1 {
  margin: 0;
  font-size: clamp(3rem, 15vw, 5rem);
}
</style>
